import { disableDefaultHStyleMixin } from 'constants/styles/mixins';
import { GRAY_80 } from 'ui-kit/GlobalStyle/colors';
import styled from 'styled-components';

export const Text = styled.p`
    font-size: 16px;
    line-height: 17px;
    color: ${GRAY_80};
    margin-bottom: 8px;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
`;

export const LeftContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-right: 60px;
`;

export const BodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const Title = styled.h3`
    ${disableDefaultHStyleMixin};
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
`;

export const Price = styled.span`
    font-size: 14px;
    color: ${GRAY_80};
    margin-bottom: 8px;
`;

export const BillingCycle = styled.span`
    font-size: 14px;
    color: ${GRAY_80};
    margin-bottom: 8px; /* Adjust margin to separate from price */
`;

export const Month = styled.span`
    font-size: 14px;
    color: ${GRAY_80};
    margin-bottom: 8px; /* Adjust margin to separate from billing cycle */
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 18px;
    right: 10px;
    background: transparent;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: ${GRAY_80};
`;
